// @ts-expect-error untyped dependency
import FormattedCurrencyLabel from 'I18n/components/FormattedCurrencyLabel';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { getPricingModelLabel } from '../constants/pricingModel';
import { TieredPriceCurrencySelect } from './header/TieredPriceCurrencySelect';
import { useHomeCurrency } from '../../../v2/hooks/useHomeCurrency';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceModalHeaderSection = ({
  effectiveCurrencyCode,
  currencyCodesWithTiersData,
  pricingModel,
  setEffectiveCurrencyCode
}) => {
  const pricingModelLabel = getPricingModelLabel(pricingModel);
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const currencyCodeToDisplay = useMemo(() => {
    if (effectiveCurrencyCode === undefined && homeCurrencyCode === undefined) {
      return undefined;
    }
    return effectiveCurrencyCode !== null && effectiveCurrencyCode !== void 0 ? effectiveCurrencyCode : homeCurrencyCode;
  }, [effectiveCurrencyCode, homeCurrencyCode]);
  if (currencyCodeToDisplay === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsx(HelpIcon, {
      "data-test-id": "tiered-price-modal-pricing-method-help-icon",
      title: pricingModelLabel === null || pricingModelLabel === void 0 ? void 0 : pricingModelLabel.help,
      tooltipPlacement: "top",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "tiered-price-modal-pricing-method-info",
        message: "customerDataProperties.tieredPricing.modal.pricingMethodInfo",
        options: {
          pricingModel: pricingModelLabel === null || pricingModelLabel === void 0 ? void 0 : pricingModelLabel.label
        }
      })
    }), currencyCodesWithTiersData.length > 0 ? /*#__PURE__*/_jsx(TieredPriceCurrencySelect, {
      effectiveCurrencyCode: currencyCodeToDisplay,
      currencyCodesWithData: currencyCodesWithTiersData,
      setEffectiveCurrencyCode: setEffectiveCurrencyCode
    }) : /*#__PURE__*/_jsx("div", {
      "data-test-id": "tiered-price-modal-currency-info",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "customerDataProperties.tieredPricing.modal.defaultCurrencyInfo_jsx",
        elements: {
          FormattedCurrencyLabel
        },
        options: {
          currencyStyle: 'long',
          currencyCode: currencyCodeToDisplay
        }
      })
    })]
  });
};